export default "__VITE_ASSET__4f714a3e__"